import { createAction } from "@reduxjs/toolkit";

export const addMessage = createAction("@notification/addMessage");
export const readMessage = createAction("@notification/readMessage");
export const updatePermissionStatus = createAction("@notification/permissionStatus");
export const updatePermissionRequested = createAction("@notification/permissionRequested");
export const updateFCM = createAction("@notification/updateFCM");
